import React from 'react';

export default function CustomizationSidebar({ settings, onChange }) {
  const handleChange = (field, value) => {
    onChange(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="w-80 flex-shrink-0 sticky top-24 h-fit">
      <div className="admin-card">
        <h2 className="text-2xl font-bold text-white mb-6">Customization</h2>
        
        <div className="space-y-4">
          {/* Title */}
          <div>
            <label className="block text-white font-bold mb-2">
              Title
            </label>
            <input
              type="text"
              value={settings.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder="Publication title"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            />
          </div>

          {/* Author */}
          <div>
            <label className="block text-white font-bold mb-2">
              Author
            </label>
            <input
              type="text"
              value={settings.author}
              onChange={(e) => handleChange('author', e.target.value)}
              placeholder="Author name"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            />
          </div>

          {/* Affiliation */}
          <div>
            <label className="block text-white font-bold mb-2">
              Affiliation (Optional)
            </label>
            <input
              type="text"
              value={settings.affiliation}
              onChange={(e) => handleChange('affiliation', e.target.value)}
              placeholder="University or organization"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            />
          </div>

          {/* Citation Style */}
          <div>
            <label className="block text-white font-bold mb-2">
              Citation Style
            </label>
            <select
              value={settings.citationStyle}
              onChange={(e) => handleChange('citationStyle', e.target.value)}
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            >
              <option value="APA">APA</option>
              <option value="MLA">MLA</option>
              <option value="Chicago">Chicago</option>
              <option value="IEEE">IEEE</option>
            </select>
          </div>

          {/* Tone/Style */}
          <div>
            <label className="block text-white font-bold mb-2">
              Tone/Style Preset
            </label>
            <select
              value={settings.tone}
              onChange={(e) => handleChange('tone', e.target.value)}
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            >
              <option value="academic">Academic</option>
              <option value="narrative">Narrative</option>
              <option value="technical">Technical</option>
            </select>
          </div>

          {/* Readability Target */}
          <div>
            <label className="block text-white font-bold mb-2">
              Readability Target
            </label>
            <input
              type="text"
              value={settings.readabilityTarget}
              onChange={(e) => handleChange('readabilityTarget', e.target.value)}
              placeholder="e.g., Grade 12, College"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            />
          </div>

          {/* Word Count Target */}
          <div>
            <label className="block text-white font-bold mb-2">
              Word Count Target (per paragraph)
            </label>
            <input
              type="number"
              value={settings.wordCountTarget}
              onChange={(e) => handleChange('wordCountTarget', e.target.value)}
              placeholder="e.g., 250"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded focus:outline-none focus:border-[#6B4423]"
            />
          </div>

          {/* Excluded Words */}
          <div>
            <label className="block text-white font-bold mb-2">
              Words to Exclude
            </label>
            <textarea
              value={settings.excludedWords || ''}
              onChange={(e) => handleChange('excludedWords', e.target.value)}
              placeholder="e.g., crucial, vital, essential (comma-separated)"
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded h-20 resize-y focus:outline-none focus:border-[#6B4423]"
            />
            <p className="text-xs text-[#F4E4C1] mt-1">
              AI will try to avoid using these words
            </p>
          </div>

          {/* Global Terminology */}
          <div>
            <label className="block text-white font-bold mb-2">
              Global Terminology/Abbreviations
            </label>
            <textarea
              value={settings.terminology || ''}
              onChange={(e) => handleChange('terminology', e.target.value)}
              placeholder="Define key terms, abbreviations..."
              className="w-full px-3 py-2 border-2 border-[#8B6F47] rounded h-24 resize-y focus:outline-none focus:border-[#6B4423]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
